import { gql } from 'apollo-angular';

export const getAccountListQuery = gql`
  query GetAccounts(
    $first: Int!
    $where: AccountFilterInput
    $order: [AccountSortInput!]
    $after: String
    $npi: String
  ) {
    accounts(
      first: $first
      where: $where
      order: $order
      after: $after
      npi: $npi
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        pms
        accountNumber
        name
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZipcode
        contactName
        contactPhone
        contactFax
        contactEmail
        ecsStatus
        ecsDate
        eraStatus
        eraDate
        claimStatusStatus
        claimStatusDate
        eligibilityStatus
        eligibilityDate
        statementStatus
        statementDate
        dateSetup
        dateTerminated
        dateLastDbUpdated
        usersClientsAccts {
          id
          accountNumber
        }
        eligibilityStatus
        eligibilityDate
        creditCardNo
        isActive
      }
    }
  }
`;

export const getAccountQuery = gql`
  query account($accountNumber: String) {
    account(accountNumber: $accountNumber) {
      pMS
      accountNumber
      name
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZipcode
      contactName
      contactPhone
      contactFax
      contactEmail
      providerGroups {
        name
        groupId
        recordStatus
        organizationType
        feeSchedule
        ecsStatus
        eraStatus
        claimStatusStatus
        eligibilityStatus
        statementStatus
        providers {
          id
          lastName
          firstName
          organizationType
          organizationName
          recordStatus
          providerGroupId
        }
        # provider group: batch remmitance fields
        batch277ca
        batch277u
        batchCSV
        batchHumanReadable
        batchMachineReadable
        batchXml
        remit277ca
        remit277u
        remitCSVDaily
        remitHumanReadable
        remitMachineReadable
        remitXml
        remitCsv
        humanReadable271
        rejectPrintClaims
        alphaII
        combineERA
      }
      ecsStatus
      ecsDate
      eraStatus
      eraDate
      claimStatusStatus
      claimStatusDate
      eligibilityStatus
      eligibilityDate
      statementStatus
      statementDate
      dateSetup
      dateTerminated
      dateLastDbUpdated
      lastDbUpdatedBy
      notes
      taxExempt
      isActive
    }
  }
`;

export const getFees = gql`
  {
    fees(order: { name: ASC }) {
      nodes {
        id
        name
        recordStatus
        dateSetup
        dateTerminate
        dateLastDbUpdate
        paperClaims
        serviceFee
        installFee
        freeDays
        taxRate
        statementsFirstPage
        statementsAdditionalPages
        ecsFeeNonPar
        eraFeeNonPar
        eraFeePar
        eligibilityFeeNonPar
        eligibilityFeePar
        claimStatusNonPar
        claimStatusPar
        ediFee
      }
    }
  }
`;

export const getFeesIdList = gql`
  query GetFeesIdList($first: Int!, $order: [FeeSortInput!]) {
    fees(first: $first, order: $order) {
      nodes {
        id
        name
      }
    }
  }
`;

export const getAccountsByApplication = gql`
  query GetAccounts(
    $first: Int!
    $where: AccountFilterInput
    $order: [AccountSortInput!]
    $after: String
  ) {
    accounts(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        accountNumber
        name
      }
    }
  }
`;

export const getAccountsGroupsIdList = gql`
  query getAccountsGroupsIdList(
    $first: Int!
    $where: AccountFilterInput
    $order: [AccountSortInput!]
    $after: String
  ) {
    accounts(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        accountNumber
        providerGroups {
          groupId
        }
      }
    }
  }
`;
